import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function GoalGetterIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3812" data-mp="1dgn7ty6qwlom">
      <div className="relative w-full h-full bg-gradient-to-br from-teal-100 to-emerald-200 overflow-hidden" data-id="element-3813" data-mp="14hs02ho1z3j7">
        {/* Background: Target Board */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3814" data-mp="pmlwe1cfjgt1">
          {/* Target */}
          <g transform="translate(140, 60)" data-id="element-3815" data-mp="2jzlkkiuvljbx">
            <circle cx="0" cy="0" r="45" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="2" data-id="element-3816" data-mp="2oyeuk1ayes7c" />
            <circle cx="0" cy="0" r="30" fill="#EF4444" data-id="element-3817" data-mp="v61u5hvw2nbw" />
            <circle cx="0" cy="0" r="15" fill="#FFFFFF" data-id="element-3818" data-mp="v5id03e2c2yx" />
            <circle cx="0" cy="0" r="5" fill="#EF4444" data-id="element-3819" data-mp="19uy11bm7luax" />

            {/* Arrow stuck in bullseye */}
            {isUnlocked && <g transform="rotate(-45)" data-id="element-3820" data-mp="14w3j0bw2g9rv">
                <path d="M0 0 L-40 0" stroke="#94A3B8" strokeWidth="3" strokeLinecap="round" data-id="element-3821" data-mp="h5zdfyzbhzy8" />
                <path d="M-30 -5 L-40 0 L-30 5" fill="#38BDF8" data-id="element-3822" data-mp="c990vlmq1mhk" />
              </g>}
          </g>

          {/* Ground */}
          <path d="M0 160 L200 160 L200 200 L0 200 Z" fill="#34D399" opacity="0.5" data-id="element-3823" data-mp="m4kf82u7wros" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-start pb-[15%] pl-[10%]" data-id="element-3824" data-mp="21np2c0ir2971">
          <div className="w-[60%] h-[60%] flex items-center justify-center" data-id="element-3825" data-mp="1xmlk57d8c12n">
            <DjaySpecimen look={{
            variant,
            accessory: 'medal'
          }} size="hero" emotion={isUnlocked ? 'happy' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3826" data-mp="u93f76h9upk8" />
          </div>
        </div>

        {/* Foreground: Action lines */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3827" data-mp="bkom8dne91gs">
            {/* Arrow flight path */}
            <path d="M80 100 Q110 80 135 65" stroke="#94A3B8" strokeWidth="2" strokeDasharray="4 4" opacity="0.5" data-id="element-3828" data-mp="paiel5y3y3v9" />

            {/* Celebration sparks near target */}
            <path d="M140 10 L140 20 M140 100 L140 110 M90 60 L100 60 M180 60 L190 60" stroke="#FDE047" strokeWidth="3" strokeLinecap="round" data-id="element-3829" data-mp="3sx8zl743pvth" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}